import { useEffect, useState } from 'react';

export const useScheduled = (finishTime?: string) => {
  const [isFinished, setIsFinished] = useState(!!finishTime && Date.parse(finishTime) < Date.now());

  useEffect(() => {
    if (!finishTime) {
      return;
    }

    const leftTime = Date.parse(finishTime) - Date.now();

    const timeoutId = setTimeout(() => {
      setIsFinished(true);
    }, Math.max(leftTime, 0));

    return () => clearTimeout(timeoutId);
  }, []);

  return isFinished;
};

export default useScheduled;
